import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import apiService from '../../services/apiServices'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import Moment from 'react-moment';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { spacing } from '@mui/system';
import { Bars } from 'react-loader-spinner'
import { useForm, Controller } from 'react-hook-form';
import helper from '../../services/helper';

const CreditorMonthlyReport = () => {
    const [loader, setLoader] = useState(true);
    const [items, setItems] = useState()
    const [modal, setModal] = useState({});
    const [rowId, setRowId] = useState({});
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const current = new Date()
    const [searchQuery, setSearchQuery] = useState({ month: (current.getMonth()), year: current.getFullYear() })

    const {
        register,
        handleSubmit,
        setValue,
        watch,
        control,
        formState: { errors },
    } = useForm();

    const months = [
        { no: 1, name: 'Janar' },
        { no: 2, name: 'Shkurt' },
        { no: 3, name: 'Mars' },
        { no: 4, name: 'Prill' },
        { no: 5, name: 'Maj' },
        { no: 6, name: 'Qershor' },
        { no: 7, name: 'Korrik' },
        { no: 8, name: 'Gusht' },
        { no: 9, name: 'Shtator' },
        { no: 10, name: 'Tetor' },
        { no: 11, name: 'Nentor' },
        { no: 12, name: 'Dhjetor' }
    ]

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleDelete = (id) => {
        apiService()
            .delete('salariesmonthlylists', id)
            .then((response) => {
                if (response) {
                    setModal({ open: false });
                    setToast({
                        open: true,
                        message: 'U fshi me sukses!',
                        variant: 'success',
                    });
                    //   setSalaries1(salaries1.filter((salary) => salary.id !== id));
                } else {
                    setModal({ open: false });
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
            });
    };

    const openModal = (id) => {
        setModal({
            open: true,
            tittle: 'Delete',
            message: 'Do you want to delete this row?',
        });
        setToast({ open: false });
        setRowId(id);
    };

    const exportCsv = (fileName = 'test') => {
        // helper().exportCsv(items, true, 'creditor_report')

        var htmls = "";
        var table = document.getElementById('print') ? document.getElementById('print') : document.getElementById('table-to-xls-1');
        htmls = table?.outerHTML;

        var link = document.createElement("a");
        link.download = fileName + ".xls";
        link.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(htmls);
        link.click();
    }

    const totalMonthAmount = () => {
        let result = items?.reduce((accumulator, current) => parseFloat(accumulator) + current.Amount, 0);
        return result?.toLocaleString("en-US")
    }

    const getCompanyData = () => {
        apiService().get("settings").then(response => {
            const fields = Object.keys(response.data[0]);
            fields.map((field) =>
                setValue(field, response.data[0][field])
            );
        })
    }

    const getData = () => {
        setLoader(true)
        apiService().query('creditorMounthReport', `month=${searchQuery.month}&year=${searchQuery.year}`)
            .then(response => {
                if (response.success && response.data.length > 0) {
                    console.log('rep: ', response)
                    setItems(response?.data)
                    setLoader(false)
                }
                else {
                    setLoader(false)
                    setItems([])
                }
            })
    }
    useEffect(() => {
        console.log(searchQuery)
        getData()
    }, [searchQuery.month])

    useEffect(() => {
        console.log(current)
        getData()
        getCompanyData()
    }, [])

    return (
        <div>
            <div>
                {loader && <div className="loader-class"><Bars
                    height="70"
                    width="100%"
                    color="#1976d2"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                /></div>}
                {!loader && <>
                    <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
                    <Toast {...toast} />
                    <TopActions newHref="/salarieslist/addlist" saveHref="/dashboard/" monthYearSelect={true} setSearchQuery={(e, name) => setSearchQuery({ ...searchQuery, [name]: parseInt(e.target.value) })} months={months} month={searchQuery.month} year={searchQuery.year} search={getData} exportToCsv={() => exportCsv(months.find(m => m.no === searchQuery.month).name+"_"+searchQuery.year)} />



                    <TableContainer id="print" component={Paper}>
                        <Table className='creditorHeadTable' style={{display: 'none'}}>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell style={{fontWeight: 'bolder', fontSize:'16px'}} colSpan={3}>Emri: {watch("CompanyName")}</TableCell>
                            </TableRow>
                            <TableRow>
                            <TableCell></TableCell>
                                <TableCell style={{fontWeight: 'bolder', fontSize:'16px'}} colSpan={3}>NUI: {watch("NUI")}</TableCell>
                                <TableCell style={{fontWeight: 'bolder', fontSize:'16px'}} colSpan={3}>Banka: {watch("BankName")}</TableCell>
                            </TableRow>
                            <TableRow>
                            <TableCell></TableCell>
                                <TableCell style={{fontWeight: 'bolder', fontSize:'16px'}} colSpan={3}>Adresa: {watch("Address")}</TableCell>
                                <TableCell style={{fontWeight: 'bolder', fontSize:'16px'}} colSpan={3}>Xhirollogaria: {watch("BankAccount")}</TableCell>
                            </TableRow>
                            <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell colSpan={4} style={{fontWeight: 'bolder', fontSize:'16px'}}>
                                    Urdhëresa për pagesën e rrogave të punëtorëve për muajin: {months.find(m => m.no === searchQuery.month).name}
                                </TableCell>
                                <TableCell style={{fontWeight: 'bolder', fontSize:'16px'}}>{totalMonthAmount()}</TableCell>
                            </TableRow>
                            <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                        </Table>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nr</TableCell>
                                    <TableCell>Creditor name</TableCell>
                                    <TableCell>Id</TableCell>
                                    <TableCell>BankAccount</TableCell>
                                    <TableCell>Type of job</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Branch</TableCell>
                                    {/* <TableCell style={{ width: '50px' }}></TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items?.length == 0 &&
                                    <TableRow>
                                        <TableCell colSpan={8} style={{ textAlign: 'center' }}>No Data</TableCell>
                                    </TableRow>
                                }
                                {items?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((w, index) => (
                                        <TableRow key={w.id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{w.CreditorName}</TableCell>
                                            <TableCell>{w.Id}</TableCell>
                                            <TableCell> {w.CreditorIBAN}</TableCell>
                                            <TableCell>{w.TypeOfJob}</TableCell>
                                            <TableCell>{w.Amount}</TableCell>
                                            <TableCell>{w.Branch}</TableCell>
                                            {/* <TableCell>
                                                <ButtonGroup size="small">
                                                    <Link to={`salarieslist/editlist/${w.id}`}>
                                                        <Button>
                                                            <EditIcon />
                                                        </Button>
                                                    </Link>
                                                    <Button onClick={() => openModal(w.id)}>
                                                        <DeleteIcon />
                                                    </Button>
                                                </ButtonGroup>
                                            </TableCell> */}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={items?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </>}
            </div>
        </div>
    )
}

export default CreditorMonthlyReport